import React, {useState} from 'react';
import {inject} from "mobx-react";

import AirModal from "../../../../common/components/AirModal";
import {CheckmarkSquareIcon, ChevronDownIcon, ChevronUpIcon} from "../../../../common/icons";
import MyPageButton from "../../../../common/components/MyPageButton";

import "../../../../common/components/ProductCard/ProductCard.css"

const CardFront = inject('translationsStore')(({product, logo, description, subscription, onSelect, translationsStore}) => (
  <React.Fragment>
    <img
      alt="product"
      src={`products/${logo}.png`}
    />
    <div className="CardContent">
      <div className="TextContainer">
        <p className="Description FrontDescription">Acquista a 500€ grazie allo <b>SCONTO AIR</b></p>
      </div>
      <MyPageButton
        theme="fit2you"
        solid
        title={translationsStore.translate('servicesView.serviceCard.fit2youSubmitButton')}
        onClick={() => onSelect(product)}
      />
    </div>
  </React.Fragment>
));

const CardBack = inject('translationsStore')(({features, isFront, onFlip, translationsStore}) => (
  <div className={isFront?"CardBack closed":"CardBack"}>
    <div className="CardBackHeader" onClick={onFlip} >
      + info {
      isFront
        ? <ChevronDownIcon className="BackIcon" width={12} height={12} />
        : <ChevronUpIcon className="BackIcon" width={12} height={12} />
    }

    </div>
      <img
        alt="product"
        src={`products/Fit2you_head.png`}
      />
    <div className="CardContent">
      <div className="TextContainer">
        {
          features
            .map(feature => translationsStore.translate('servicesView.serviceCard.features.'+feature))
            .flat()
            .map((feature, index) =>
              <div key={index} className="ListItemContainer">
                <div className="ListIcon"><CheckmarkSquareIcon width={16} height={16} /></div>
                <p className="Description">{feature}</p>
              </div>
            )
        }
      </div>
    </div>
  </div>
));

const Fit2YouCard = ({subscriptions, ...otherProps}) => {
  const [isFront, setIsFront] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <div className="ProductCard Fit2YouCard">
      <CardFront {...otherProps} onSelect={() => setModalVisible(true)} />
      <CardBack {...otherProps} isFront={isFront} onFlip={() => setIsFront(!isFront)} />
      <AirModal
        width="60vw"
        className="EmbeddedDocumentModal Fit2YouModal"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
      >
        <h4>La tua richiesta di informazioni è stata trasmessa a <span className="emp">Fit2You</span> che ti contatterà il prima possibile!</h4>
      </AirModal>
    </div>
  )
};

export default Fit2YouCard;
